/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Action_Cancel_Seat_ChangeInputs */



/**
* | output |
* | --- |
* | "Undo waiting change" |
*
* @param {Members_Action_Cancel_Seat_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_action_cancel_seat_change = /** @type {((inputs?: Members_Action_Cancel_Seat_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Action_Cancel_Seat_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplante Änderung zurücknehmen")
	return /** @type {LocalizedString} */ ("Undo waiting change")
});